/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable default-param-last */
import { produce } from 'immer';

import {
  PNL_ANALYTICS_API_ACTION_TYPES,
  UPDATE_CONTRACT_TYPE,
  UPDATE_DURATION,
  UPDATE_FUNDING_CHART_DATA,
  UPDATE_SELECTED_CURRENCY,
} from 'actionTypes/pnlAnaltyics';
import { CONTRACT_FILTERS } from 'components/accountAnalytics/AccountAnalytics.constants';
import type { FundingRecord } from 'components/accountAnalytics/AccountAnalytics.types';
import {
  getDefaultCurrency,
  getStoredCurrency,
} from 'components/accountAnalytics/charts/FundingChart/FundingCharts.helpers';
import { API_STATUS } from 'constants/enums';
import type { ContractTypeFilter } from 'types/Istore';

export interface PnlAnalytics {
  fundingChart: {
    records: FundingRecord[];
    loading: boolean;
    error: string;
  };
  duration: {
    startTime: string;
    endTime: string;
  };
  contractType: ContractTypeFilter;
  selectedCurrency: string;
  scalperRebateData: {
    apiStatus: API_STATUS;
    data: {
      perpetual_futures: string;
      futures: string;
      put_options: string;
      call_options: string;
      total_rebate: string;
    };
  };
}

const storedCurrency = getStoredCurrency() as string;
const defaultCurrency = getDefaultCurrency() as string;
const selectedCurrency = storedCurrency || defaultCurrency;

const initialState: PnlAnalytics = {
  fundingChart: {
    records: [],
    loading: false,
    error: '',
  },
  duration: {
    startTime: '',
    endTime: '',
  },
  contractType: CONTRACT_FILTERS.ALL,
  selectedCurrency,
  scalperRebateData: {
    apiStatus: API_STATUS.IDLE,
    data: {
      perpetual_futures: '',
      futures: '',
      put_options: '',
      call_options: '',
      total_rebate: '',
    },
  },
};

const pnlAnalyticsReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case UPDATE_FUNDING_CHART_DATA:
      draft.fundingChart.records = action.payload;
      break;

    case UPDATE_DURATION:
      draft.duration = action.payload;
      break;

    case UPDATE_CONTRACT_TYPE:
      draft.contractType = action.payload;
      break;
    case UPDATE_SELECTED_CURRENCY:
      draft.selectedCurrency = action.payload;
      break;

    case PNL_ANALYTICS_API_ACTION_TYPES.FETCH_FUNDING_CHART_DATA.SUCCESS:
      draft.fundingChart = {
        ...draft.fundingChart,
        loading: false,
        records: action.result.result, // TODO: check this with backend
        error: '',
      };
      break;

    case PNL_ANALYTICS_API_ACTION_TYPES.FETCH_FUNDING_CHART_DATA.FAIL:
      draft.fundingChart = {
        ...draft.fundingChart,
        loading: false,
        records: [],
        error: action.error, // TODO: check this with backend
      };
      break;

    case PNL_ANALYTICS_API_ACTION_TYPES.FETCH_FUNDING_CHART_DATA.LOAD:
      draft.fundingChart = {
        ...draft.fundingChart,
        loading: true,
        records: [],
        error: '',
      };
      break;

    case PNL_ANALYTICS_API_ACTION_TYPES.GET_ACCOUNT_ANALYTICS_SCALPER_REBATE.LOAD:
      draft.scalperRebateData.apiStatus = API_STATUS.LOADING;
      break;

    case PNL_ANALYTICS_API_ACTION_TYPES.GET_ACCOUNT_ANALYTICS_SCALPER_REBATE.SUCCESS:
      draft.scalperRebateData.apiStatus = API_STATUS.SUCCESS;
      draft.scalperRebateData.data.perpetual_futures =
        action.result.result.perpetual_futures || '0';
      draft.scalperRebateData.data.futures = action.result.result.futures || '0';
      draft.scalperRebateData.data.put_options = action.result.result.put_options || '0';
      draft.scalperRebateData.data.call_options =
        action.result.result.call_options || '0';
      draft.scalperRebateData.data.total_rebate =
        action.result.result.total_rebate || '0';
      break;

    case PNL_ANALYTICS_API_ACTION_TYPES.GET_ACCOUNT_ANALYTICS_SCALPER_REBATE.FAIL:
      draft.scalperRebateData.apiStatus = API_STATUS.ERROR;
      break;

    default:
      return draft;
  }
});

export default pnlAnalyticsReducer;
